// Minimal typed wrapper over the global Telegram.WebApp injected by telegram-web-app.js.

interface TgWebApp {
  initData: string;
  initDataUnsafe: {
    user?: {
      id: number;
      username?: string;
      first_name?: string;
      language_code?: string;
      photo_url?: string;
    };
  };
  platform?: string;
  version?: string;
  ready: () => void;
  expand: () => void;
  themeParams: Record<string, string>;
  colorScheme: 'light' | 'dark';
  MainButton: {
    setText: (t: string) => void;
    show: () => void;
    hide: () => void;
    onClick: (fn: () => void) => void;
    offClick: (fn: () => void) => void;
  };
  HapticFeedback: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void;
    notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
  };
  showAlert: (msg: string) => void;
  showConfirm: (msg: string, cb: (ok: boolean) => void) => void;
  openLink?: (url: string, options?: { try_instant_view?: boolean }) => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp };
  }
}

export function getTg(): TgWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function getInitData(): string {
  const tg = getTg();
  if (!tg) {
    // dev-mode fallback so the app boots outside Telegram
    return import.meta.env.DEV ? (import.meta.env.VITE_DEV_INIT_DATA as string) ?? '' : '';
  }
  return tg.initData ?? '';
}

export function initTelegram() {
  const tg = getTg();
  if (!tg) return;
  tg.ready();
  tg.expand();
}
